export default __webpack_public_path__ + "static/media/success-register-pendency.c8bd2569.png";